import './privacy-policy.svelte.css.proxy.js';
/* src/routes/privacy-policy.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	noop,
	query_selector_all,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import Nav from "../../_components/navigation/Nav.svelte.js";
import Wrap from "../../_components/slot/Wrap.svelte.js";
import Inner from "../../_components/slot/Inner.svelte.js";
import Section from "../../_components/slot/Section.svelte.js";
import Breadcrumb from "../../_components/block/Breadcrumb.svelte.js";
import Title from "../../_components/block/Title.svelte.js";
import Item from "../../_components/slot/Item.svelte.js";

function create_default_slot_5(ctx) {
	let breadcrumb;
	let t;
	let title;
	let current;
	breadcrumb = new Breadcrumb({ props: { paths: /*paths*/ ctx[0] } });

	title = new Title({
			props: { name: "プライバシーポリシー", en: "Privacy policy" }
		});

	return {
		c() {
			create_component(breadcrumb.$$.fragment);
			t = space();
			create_component(title.$$.fragment);
		},
		l(nodes) {
			claim_component(breadcrumb.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(title.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(breadcrumb, target, anchor);
			insert(target, t, anchor);
			mount_component(title, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(breadcrumb.$$.fragment, local);
			transition_in(title.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(breadcrumb.$$.fragment, local);
			transition_out(title.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(breadcrumb, detaching);
			if (detaching) detach(t);
			destroy_component(title, detaching);
		}
	};
}

// (31:0) <Section kind="top-small">
function create_default_slot_4(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (70:6) <Item>
function create_default_slot_3(ctx) {
	let button;
	let img;
	let img_src_value;
	let t0;
	let span;
	let t1;
	let mounted;
	let dispose;

	return {
		c() {
			button = element("button");
			img = element("img");
			t0 = space();
			span = element("span");
			t1 = text("閉じる");
			this.h();
		},
		l(nodes) {
			button = claim_element(nodes, "BUTTON", { class: true });
			var button_nodes = children(button);
			img = claim_element(button_nodes, "IMG", { src: true, alt: true, class: true });
			t0 = claim_space(button_nodes);
			span = claim_element(button_nodes, "SPAN", {});
			var span_nodes = children(span);
			t1 = claim_text(span_nodes, "閉じる");
			span_nodes.forEach(detach);
			button_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/cross.png")) attr(img, "src", img_src_value);
			attr(img, "alt", "×");
			attr(img, "class", "svelte-n4m6ex");
			attr(button, "class", "close svelte-n4m6ex");
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, img);
			append(button, t0);
			append(button, span);
			append(span, t1);

			if (!mounted) {
				dispose = listen(button, "click", close);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

// (40:4) <Inner>
function create_default_slot_2(ctx) {
	let p0;
	let t0;
	let t1;
	let h20;
	let t2;
	let t3;
	let p1;
	let t4;
	let t5;
	let h21;
	let t6;
	let t7;
	let p2;
	let t8;
	let t9;
	let h22;
	let t10;
	let t11;
	let p3;
	let t12;
	let t13;
	let h23;
	let t14;
	let t15;
	let p4;
	let t16;
	let t17;
	let ol;
	let li0;
	let t18;
	let t19;
	let li1;
	let t20;
	let t21;
	let li2;
	let t22;
	let t23;
	let p5;
	let t24;
	let t25;
	let br0;
	let t26;
	let div;
	let t27;
	let br1;
	let t28;
	let t29;
	let item;
	let current;

	item = new Item({
			props: {
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			p0 = element("p");
			t0 = text("弊社は、お客様の個人情報を適切に保護・管理するため、その取扱いにつきましては細心の注意を払っております。");
			t1 = space();
			h20 = element("h2");
			t2 = text("1. 関係法令等の遵守");
			t3 = space();
			p1 = element("p");
			t4 = text("弊社は、個人情報(生存する個人に関する情報であって、特定の個人を識別できるものをいい、以下も同様とします。)を取扱う際に、個人情報保護法を はじめとする個人情報保護に関する関係諸法令を厳正に遵守することを誓約します。");
			t5 = space();
			h21 = element("h2");
			t6 = text("2.個人情報の利用目的");
			t7 = space();
			p2 = element("p");
			t8 = text("弊社は、利用目的を明示し、それ以外の目的に無断で利用しないものとし、適切な取得と利用に取組みます。");
			t9 = space();
			h22 = element("h2");
			t10 = text("3.安全管理措置");
			t11 = space();
			p3 = element("p");
			t12 = text("弊社は、個人情報は保護すべき重要な情報であると認識し、お客様の個人情報を収集した際には、厳重に管理・保管致します。また、安全管理のために 必要な情報セキュリティ対策を講じ、従業者および委託先を監督します。");
			t13 = space();
			h23 = element("h2");
			t14 = text("4.個人情報の開示");
			t15 = space();
			p4 = element("p");
			t16 = text("弊社は、お客様よりお預かりした個人情報に関し、次のいずれかに該当する場合を除き、個人情報を第三者に開示致しません。");
			t17 = space();
			ol = element("ol");
			li0 = element("li");
			t18 = text("お客さまの同意がある場合。");
			t19 = space();
			li1 = element("li");
			t20 = text("お客さまが希望されるサービスを行なうために弊社が業務を委託する業者に対して開示する場合。");
			t21 = space();
			li2 = element("li");
			t22 = text("法令に基づき開示することが必要である場合。");
			t23 = space();
			p5 = element("p");
			t24 = text("弊社は、保有個人情報に関し、お客様からの開示、訂正、利用停止等の請求につきましては、誠意をもって対応します。");
			t25 = space();
			br0 = element("br");
			t26 = space();
			div = element("div");
			t27 = text("令和3年1月1日");
			br1 = element("br");
			t28 = text("\n        協和自動車有限会社");
			t29 = space();
			create_component(item.$$.fragment);
			this.h();
		},
		l(nodes) {
			p0 = claim_element(nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t0 = claim_text(p0_nodes, "弊社は、お客様の個人情報を適切に保護・管理するため、その取扱いにつきましては細心の注意を払っております。");
			p0_nodes.forEach(detach);
			t1 = claim_space(nodes);
			h20 = claim_element(nodes, "H2", { class: true });
			var h20_nodes = children(h20);
			t2 = claim_text(h20_nodes, "1. 関係法令等の遵守");
			h20_nodes.forEach(detach);
			t3 = claim_space(nodes);
			p1 = claim_element(nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t4 = claim_text(p1_nodes, "弊社は、個人情報(生存する個人に関する情報であって、特定の個人を識別できるものをいい、以下も同様とします。)を取扱う際に、個人情報保護法を はじめとする個人情報保護に関する関係諸法令を厳正に遵守することを誓約します。");
			p1_nodes.forEach(detach);
			t5 = claim_space(nodes);
			h21 = claim_element(nodes, "H2", { class: true });
			var h21_nodes = children(h21);
			t6 = claim_text(h21_nodes, "2.個人情報の利用目的");
			h21_nodes.forEach(detach);
			t7 = claim_space(nodes);
			p2 = claim_element(nodes, "P", { class: true });
			var p2_nodes = children(p2);
			t8 = claim_text(p2_nodes, "弊社は、利用目的を明示し、それ以外の目的に無断で利用しないものとし、適切な取得と利用に取組みます。");
			p2_nodes.forEach(detach);
			t9 = claim_space(nodes);
			h22 = claim_element(nodes, "H2", { class: true });
			var h22_nodes = children(h22);
			t10 = claim_text(h22_nodes, "3.安全管理措置");
			h22_nodes.forEach(detach);
			t11 = claim_space(nodes);
			p3 = claim_element(nodes, "P", { class: true });
			var p3_nodes = children(p3);
			t12 = claim_text(p3_nodes, "弊社は、個人情報は保護すべき重要な情報であると認識し、お客様の個人情報を収集した際には、厳重に管理・保管致します。また、安全管理のために 必要な情報セキュリティ対策を講じ、従業者および委託先を監督します。");
			p3_nodes.forEach(detach);
			t13 = claim_space(nodes);
			h23 = claim_element(nodes, "H2", { class: true });
			var h23_nodes = children(h23);
			t14 = claim_text(h23_nodes, "4.個人情報の開示");
			h23_nodes.forEach(detach);
			t15 = claim_space(nodes);
			p4 = claim_element(nodes, "P", { class: true });
			var p4_nodes = children(p4);
			t16 = claim_text(p4_nodes, "弊社は、お客様よりお預かりした個人情報に関し、次のいずれかに該当する場合を除き、個人情報を第三者に開示致しません。");
			p4_nodes.forEach(detach);
			t17 = claim_space(nodes);
			ol = claim_element(nodes, "OL", { class: true });
			var ol_nodes = children(ol);
			li0 = claim_element(ol_nodes, "LI", { class: true });
			var li0_nodes = children(li0);
			t18 = claim_text(li0_nodes, "お客さまの同意がある場合。");
			li0_nodes.forEach(detach);
			t19 = claim_space(ol_nodes);
			li1 = claim_element(ol_nodes, "LI", { class: true });
			var li1_nodes = children(li1);
			t20 = claim_text(li1_nodes, "お客さまが希望されるサービスを行なうために弊社が業務を委託する業者に対して開示する場合。");
			li1_nodes.forEach(detach);
			t21 = claim_space(ol_nodes);
			li2 = claim_element(ol_nodes, "LI", { class: true });
			var li2_nodes = children(li2);
			t22 = claim_text(li2_nodes, "法令に基づき開示することが必要である場合。");
			li2_nodes.forEach(detach);
			ol_nodes.forEach(detach);
			t23 = claim_space(nodes);
			p5 = claim_element(nodes, "P", { class: true });
			var p5_nodes = children(p5);
			t24 = claim_text(p5_nodes, "弊社は、保有個人情報に関し、お客様からの開示、訂正、利用停止等の請求につきましては、誠意をもって対応します。");
			p5_nodes.forEach(detach);
			t25 = claim_space(nodes);
			br0 = claim_element(nodes, "BR", {});
			t26 = claim_space(nodes);
			div = claim_element(nodes, "DIV", {});
			var div_nodes = children(div);
			t27 = claim_text(div_nodes, "令和3年1月1日");
			br1 = claim_element(div_nodes, "BR", {});
			t28 = claim_text(div_nodes, "\n        協和自動車有限会社");
			div_nodes.forEach(detach);
			t29 = claim_space(nodes);
			claim_component(item.$$.fragment, nodes);
			this.h();
		},
		h() {
			attr(p0, "class", "svelte-n4m6ex");
			attr(h20, "class", "svelte-n4m6ex");
			attr(p1, "class", "svelte-n4m6ex");
			attr(h21, "class", "svelte-n4m6ex");
			attr(p2, "class", "svelte-n4m6ex");
			attr(h22, "class", "svelte-n4m6ex");
			attr(p3, "class", "svelte-n4m6ex");
			attr(h23, "class", "svelte-n4m6ex");
			attr(p4, "class", "svelte-n4m6ex");
			attr(li0, "class", "svelte-n4m6ex");
			attr(li1, "class", "svelte-n4m6ex");
			attr(li2, "class", "svelte-n4m6ex");
			attr(ol, "class", "svelte-n4m6ex");
			attr(p5, "class", "svelte-n4m6ex");
		},
		m(target, anchor) {
			insert(target, p0, anchor);
			append(p0, t0);
			insert(target, t1, anchor);
			insert(target, h20, anchor);
			append(h20, t2);
			insert(target, t3, anchor);
			insert(target, p1, anchor);
			append(p1, t4);
			insert(target, t5, anchor);
			insert(target, h21, anchor);
			append(h21, t6);
			insert(target, t7, anchor);
			insert(target, p2, anchor);
			append(p2, t8);
			insert(target, t9, anchor);
			insert(target, h22, anchor);
			append(h22, t10);
			insert(target, t11, anchor);
			insert(target, p3, anchor);
			append(p3, t12);
			insert(target, t13, anchor);
			insert(target, h23, anchor);
			append(h23, t14);
			insert(target, t15, anchor);
			insert(target, p4, anchor);
			append(p4, t16);
			insert(target, t17, anchor);
			insert(target, ol, anchor);
			append(ol, li0);
			append(li0, t18);
			append(ol, t19);
			append(ol, li1);
			append(li1, t20);
			append(ol, t21);
			append(ol, li2);
			append(li2, t22);
			insert(target, t23, anchor);
			insert(target, p5, anchor);
			append(p5, t24);
			insert(target, t25, anchor);
			insert(target, br0, anchor);
			insert(target, t26, anchor);
			insert(target, div, anchor);
			append(div, t27);
			append(div, br1);
			append(div, t28);
			insert(target, t29, anchor);
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(p0);
			if (detaching) detach(t1);
			if (detaching) detach(h20);
			if (detaching) detach(t3);
			if (detaching) detach(p1);
			if (detaching) detach(t5);
			if (detaching) detach(h21);
			if (detaching) detach(t7);
			if (detaching) detach(p2);
			if (detaching) detach(t9);
			if (detaching) detach(h22);
			if (detaching) detach(t11);
			if (detaching) detach(p3);
			if (detaching) detach(t13);
			if (detaching) detach(h23);
			if (detaching) detach(t15);
			if (detaching) detach(p4);
			if (detaching) detach(t17);
			if (detaching) detach(ol);
			if (detaching) detach(t23);
			if (detaching) detach(p5);
			if (detaching) detach(t25);
			if (detaching) detach(br0);
			if (detaching) detach(t26);
			if (detaching) detach(div);
			if (detaching) detach(t29);
			destroy_component(item, detaching);
		}
	};
}

// (39:2) <Wrap>
function create_default_slot_1(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (38:0) <Section kind="small">
function create_default_slot(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

function create_fragment(ctx) {
	let meta0;
	let meta1;
	let meta2;
	let meta3;
	let meta4;
	let t0;
	let nav;
	let t1;
	let section0;
	let t2;
	let section1;
	let current;
	nav = new Nav({ props: { segment: "privacy-policy" } });

	section0 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	section1 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			meta0 = element("meta");
			meta1 = element("meta");
			meta2 = element("meta");
			meta3 = element("meta");
			meta4 = element("meta");
			t0 = space();
			create_component(nav.$$.fragment);
			t1 = space();
			create_component(section0.$$.fragment);
			t2 = space();
			create_component(section1.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-11dqd2l\"]", document.head);
			meta0 = claim_element(head_nodes, "META", { name: true, content: true });
			meta1 = claim_element(head_nodes, "META", { property: true, content: true });
			meta2 = claim_element(head_nodes, "META", { property: true, content: true });
			meta3 = claim_element(head_nodes, "META", { property: true, content: true });
			meta4 = claim_element(head_nodes, "META", { property: true, content: true });
			head_nodes.forEach(detach);
			t0 = claim_space(nodes);
			claim_component(nav.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(section0.$$.fragment, nodes);
			t2 = claim_space(nodes);
			claim_component(section1.$$.fragment, nodes);
			this.h();
		},
		h() {
			document.title = "プライバシーポリシー | 協和自動車有限会社 | 群馬県前橋市で自動車車検・修理なら協和自動車";
			attr(meta0, "name", "description");
			attr(meta0, "content", "協和自動車有限会社のプライバシーポリシーです。私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			attr(meta1, "property", "og:url");
			attr(meta1, "content", "https://kyouwaji.com/privacy-policy/");
			attr(meta2, "property", "og:title");
			attr(meta2, "content", "プライバシーポリシー | 協和自動車有限会社 | 群馬県前橋市で自動車車検・修理なら協和自動車");
			attr(meta3, "property", "og:description");
			attr(meta3, "content", "協和自動車有限会社のプライバシーポリシーです。私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			attr(meta4, "property", "og:type");
			attr(meta4, "content", "article");
		},
		m(target, anchor) {
			append(document.head, meta0);
			append(document.head, meta1);
			append(document.head, meta2);
			append(document.head, meta3);
			append(document.head, meta4);
			insert(target, t0, anchor);
			mount_component(nav, target, anchor);
			insert(target, t1, anchor);
			mount_component(section0, target, anchor);
			insert(target, t2, anchor);
			mount_component(section1, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const section0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section0_changes.$$scope = { dirty, ctx };
			}

			section0.$set(section0_changes);
			const section1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section1_changes.$$scope = { dirty, ctx };
			}

			section1.$set(section1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(nav.$$.fragment, local);
			transition_in(section0.$$.fragment, local);
			transition_in(section1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(nav.$$.fragment, local);
			transition_out(section0.$$.fragment, local);
			transition_out(section1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			detach(meta0);
			detach(meta1);
			detach(meta2);
			detach(meta3);
			detach(meta4);
			if (detaching) detach(t0);
			destroy_component(nav, detaching);
			if (detaching) detach(t1);
			destroy_component(section0, detaching);
			if (detaching) detach(t2);
			destroy_component(section1, detaching);
		}
	};
}

function close() {
	window.close();
	location.href = "contact";
}

function instance($$self) {
	const paths = [{ name: "HOME", href: "/" }, { name: "プライバシーポリシー" }];
	return [paths];
}

class Privacy_policy extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Privacy_policy;
//# sourceMappingURL=privacy-policy.svelte.js.map
